import "./style.css";

function CustomInput({ className = "", value = "", ...rest }) {
    return (
        <input
            id="custom-input"
            value={value == null ? "" : value}
            className={`form-control ${className}`}
            {...rest}
        />
    );
}
export default CustomInput;
